<template>
  <div class="rs-button-group">
    <slot />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'RsButtonGroup',
});
</script>

<style lang="scss">
@import '@/styles/_variables.scss';
.rs-button-group{
  display: inline-flex;
  .rs-button{
    border-radius: 0;
    &:first-child{
      border-top-left-radius: $global-radius;
      border-bottom-left-radius: $global-radius;
    }
    &:last-child{
      border-top-right-radius: $global-radius;
      border-bottom-right-radius: $global-radius;
    }
  }
}
</style>
